import { getLiteral } from 'utils/getLiteral';
import {
    ACTIVITIES,
    COMPANIES,
    CONTACTS,
    INTERNET_EMAIL,
    MARKETING_CAMPAIGN_ACTIVITY,
    OPPORTUNITIES,
    PHONE_CALL_LOGS,
} from 'constants/Entities';

export default () => ({
    entity: ACTIVITIES,
    columnSelectorSections: [
        {
            label: 'label_info',
            fields: [
                'firstName',
                'surname',
                'subject',
                'account',
                'contactName',
                'userEmail',
                'titleOpportunity',
                'contactTitle',
                'following',
            ],
        },
    ],
    useQuickView: true,
    useViewsInFilters: true,
    quickFilters: [
        'date',
        'activityType',
        'users',
        'companies',
        'pendingConversations',
        'isMarketingEmail',
    ],
    defaultFilters: [
        'activityType',
        'customActivities',
        'users',
        'date',
        'companies',
        'opportunities',
        'contacts',
        'environment',
        'FollowingItem',
        'pendingConversations',
        'isMarketingEmail',
    ],
    defaultCrossFilters: {
        [COMPANIES.entity]: ['hasActivity', 'date'],
        [CONTACTS.entity]: ['activityType'],
        [OPPORTUNITIES.entity]: ['hasActivity', 'date'],
    },
    filtersAddButtonSchema: [
        {
            label: getLiteral('label_standard_filters_section_title'),
            options: [
                'hasActivity',
                'activityType',
                'customActivities',
                'users',
                'companies',
                'opportunities',
                'contacts',
                'environment',
                'FollowingItem',
                'pendingConversations',
            ],
        },
        {
            label: getLiteral('label_emails'),
            options: ['subject', 'hasTracking', 'hasAttachment', 'isMarketingEmail'],
        },
        { label: getLiteral('label_info'), options: ['date', 'fcreado', 'fmodificado'] },
    ],
    columnDefs: [
        {
            colId: 'id',
            headerName: getLiteral('id'),
        },
        {
            colId: 'borrado',
            headerName: '_deleted', // no literal
        },
        {
            colId: 'firstName',
            headerName: getLiteral('label_firstname'),
        },
        {
            colId: 'surname',
            headerName: getLiteral('label_surname'),
        },
        {
            colId: 'subject',
            headerName: getLiteral('label_notes'),
        },
        {
            colId: 'commonDate',
            headerName: getLiteral('common_date'),
        },
        {
            colId: 'commonExtendedHour',
            headerName: getLiteral('common_extended_hour'),
        },
        {
            colId: 'activityType',
            headerName: getLiteral('label_activity_type'),
        },
        {
            colId: 'checkout',
            headerName: getLiteral('label_checkout'),
        },
        {
            colId: 'checkoutHour',
            headerName: getLiteral('label_checkout_hour'),
        },
        {
            colId: 'account',
            headerName: getLiteral('label_account'),
        },
        {
            colId: 'contactName',
            headerName: getLiteral('label_contact_name'),
        },
        {
            colId: 'userEmail',
            headerName: getLiteral('label_nylas_config_page_user_email'),
        },
        {
            colId: 'titleOpportunity',
            headerName: getLiteral('title_opportunity'),
        },
        {
            colId: 'contactTitle',
            headerName: getLiteral('ContactRole'),
        },
        {
            colId: 'following',
            headerName: getLiteral('label_following'),
        },
        {
            colId: 'timezone',
            headerName: getLiteral('label_timezone'),
        },
        {
            colId: 'accountId',
            headerName: getLiteral('label_account_id'),
        },
        {
            colId: 'opportunityId',
            headerName: getLiteral('label_opportunity_id'),
        },
        {
            colId: 'latitude',
            headerName: getLiteral('label_latitude'),
        },
        {
            colId: 'longitude',
            headerName: getLiteral('label_longitude'),
        },
        {
            colId: 'FollowingItem',
            headerName: getLiteral('label_following'),
        },
    ],
    forceExport: [
        'id',
        'subject',
        'commonDate',
        'commonExtendedHour',
        'activityType',
        'checkout',
        'checkoutHour',
        'timezone',
        'accountId',
        'opportunityId',
        'latitude',
        'longitude',
    ],
});

export const emails = () => ({
    entity: INTERNET_EMAIL,
    columnSelectorSections: [
        {
            label: 'label_info',
            fields: [
                'firstName',
                'surname',
                'subject',
                'account',
                'contactName',
                'userEmail',
                'titleOpportunity',
                'contactTitle',
                'following',
            ],
        },
    ],
    columnDefs: [
        {
            colId: 'id',
            headerName: getLiteral('id'),
        },
        {
            colId: 'borrado',
            headerName: '_deleted', // no literal
        },
        {
            colId: 'firstName',
            headerName: getLiteral('label_firstname'),
        },
        {
            colId: 'surname',
            headerName: getLiteral('label_surname'),
        },
        {
            colId: 'commonUserTransmisor',
            headerName: getLiteral('common_user_transmisor'),
        },
        {
            colId: 'commonUserReceiver',
            headerName: getLiteral('common_user_receiver'),
        },
        {
            colId: 'subject',
            headerName: getLiteral('label_subject'),
        },
        {
            colId: 'commonDate',
            headerName: getLiteral('common_date'),
        },
        {
            colId: 'activityType',
            headerName: getLiteral('label_activity_type'),
        },
        {
            colId: 'account',
            headerName: getLiteral('label_account'),
        },
        {
            colId: 'contactName',
            headerName: getLiteral('label_contact_name'),
        },
        {
            colId: 'userEmail',
            headerName: getLiteral('label_nylas_config_page_user_email'),
        },
        {
            colId: 'titleOpportunity',
            headerName: getLiteral('title_opportunity'),
        },
        {
            colId: 'contactTitle',
            headerName: getLiteral('ContactRole'),
        },
        {
            colId: 'following',
            headerName: getLiteral('label_following'),
        },
        {
            colId: 'timezone',
            headerName: getLiteral('label_timezone'),
        },
        {
            colId: 'accountId',
            headerName: getLiteral('label_account_id'),
        },
        {
            colId: 'opportunityId',
            headerName: getLiteral('label_opportunity_id'),
        },
    ],
    forceExport: [
        'id',
        'commonUserTransmisor',
        'commonUserReceiver',
        'subject',
        'commonDate',
        'activityType',
        'timezone',
        'accountId',
        'opportunityId',
    ],
});

export const marketingCampaign = () => ({
    entity: MARKETING_CAMPAIGN_ACTIVITY,
    columnSelectorSections: [
        {
            label: 'label_info',
            fields: [
                'id',
                'name',
                'subject',
                'commonDate',
                'firstName',
                'surname',
                'activityOwner',
                'account',
                'contactName',
            ],
        },
        {
            label: 'label_recipients',
            fields: [
                'recipientsTotal',
                'recipientsContacts',
                'recipientsAccounts',
                'recipientsLists',
            ],
        },
        {
            label: 'label_performance',
            fields: ['opensUnique', 'clicksUnique', 'bounces', 'unsubscribes'],
        },
        {
            label: 'Audit',
            fields: [
                'fcreado',
                'fmodificado',
                'createdusername',
                'modifiedusername',
                'createdusertype',
                'modifiedusertype',
            ],
        },
    ],
    columnDefs: [
        {
            colId: 'id',
            headerName: getLiteral('id'),
        },
        {
            colId: 'name',
            headerName: getLiteral('label_marketing_campaign'),
        },
        {
            colId: 'subject',
            headerName: getLiteral('label_subject'),
        },
        {
            colId: 'commonDate',
            headerName: getLiteral('common_date'),
        },
        {
            colId: 'firstName',
            headerName: getLiteral('label_firstname'),
        },
        {
            colId: 'surname',
            headerName: getLiteral('label_surname'),
        },
        {
            colId: 'activityOwner',
            headerName: getLiteral('label_owner'),
        },
        {
            colId: 'recipientsTotal',
            headerName: getLiteral('label_total'),
        },
        {
            colId: 'recipientsContacts',
            headerName: getLiteral('label_contacts'),
        },
        {
            colId: 'recipientsAccounts',
            headerName: getLiteral('label_accounts'),
        },
        {
            colId: 'recipientsLists',
            headerName: 'Lists',
        },
        {
            colId: 'opensUnique',
            headerName: getLiteral('label_marketing_campaigns_metrics_unique_opens'),
        },
        {
            colId: 'clicksUnique',
            headerName: getLiteral('label_marketing_campaigns_metrics_unique_clicks'),
        },
        {
            colId: 'bounces',
            headerName: getLiteral('label_marketing_campaigns_metrics_bounces'),
        },
        {
            colId: 'unsubscribes',
            headerName: getLiteral('label_marketing_campaigns_metrics_unsubscribed'),
        },
        {
            colId: 'account',
            headerName: getLiteral('label_account'),
        },
        {
            colId: 'contactName',
            headerName: getLiteral('label_contact_name'),
        },
        {
            colId: 'fcreado',
            headerName: getLiteral('label_created'),
        },
        {
            colId: 'fmodificado',
            headerName: getLiteral('label_modified'),
        },
        {
            colId: 'createdusername',
            headerName: getLiteral('label_created_user'),
        },
        {
            colId: 'modifiedusername',
            headerName: getLiteral('label_modified_user'),
        },
        {
            colId: 'createdusertype',
            headerName: getLiteral('label_created_user_type'),
        },
        {
            colId: 'modifiedusertype',
            headerName: getLiteral('label_modified_user_type'),
        },
    ],
    forceExport: ['id', 'name', 'subject', 'commonDate'],
});

export const phoneCalls = () => ({
    entity: PHONE_CALL_LOGS,
    columnSelectorSections: [
        {
            label: 'label_info',
            fields: [
                'firstName',
                'surname',
                'notes',
                'account',
                'contactName',
                'userEmail',
                'titleOpportunity',
                'contactTitle',
                'following',
            ],
        },
    ],
    columnDefs: [
        {
            colId: 'id',
            headerName: getLiteral('id'),
        },
        {
            colId: 'borrado',
            headerName: '_deleted', // no literal
        },
        {
            colId: 'firstName',
            headerName: getLiteral('label_firstname'),
        },
        {
            colId: 'surname',
            headerName: getLiteral('label_surname'),
        },
        {
            colId: 'durationSeconds',
            headerName: getLiteral('label_duration_seconds'),
        },
        {
            colId: 'atTime',
            headerName: getLiteral('label_at_time'),
        },
        {
            colId: 'endTime',
            headerName: getLiteral('label_end_time'),
        },
        {
            colId: 'activityType',
            headerName: getLiteral('label_activity_type'),
        },
        {
            colId: 'number',
            headerName: getLiteral('label_number'),
        },
        {
            colId: 'notes',
            headerName: getLiteral('label_notes'),
        },
        {
            colId: 'account',
            headerName: getLiteral('label_account'),
        },
        {
            colId: 'contactName',
            headerName: getLiteral('label_contact_name'),
        },
        {
            colId: 'userEmail',
            headerName: getLiteral('label_nylas_config_page_user_email'),
        },
        {
            colId: 'titleOpportunity',
            headerName: getLiteral('title_opportunity'),
        },
        {
            colId: 'contactTitle',
            headerName: getLiteral('ContactRole'),
        },
        {
            colId: 'following',
            headerName: getLiteral('label_following'),
        },
        {
            colId: 'timezone',
            headerName: getLiteral('label_timezone'),
        },
        {
            colId: 'accountId',
            headerName: getLiteral('label_account_id'),
        },
        {
            colId: 'opportunityId',
            headerName: getLiteral('label_opportunity_id'),
        },
    ],
    forceExport: [
        'id',
        'notes',
        'durationSeconds',
        'atTime',
        'endTime',
        'activityType',
        'number',
        'timezone',
        'accountId',
        'opportunityId',
    ],
});
